import { useEffect } from "react";
import { mediaUrl } from "@/lib/api";

const PUBLIC_URL = "https://idovent.com";

function upsertMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

export const Seo = ({ content, event }) => {
  useEffect(() => {
    if (!content) return;
    const seo = content.seo || {};
    const title = seo.meta_title || "Coorg Infinity Run 2027 — Run Beyond Limits";
    const desc = seo.meta_description || content.hero_tagline || "";
    const ogImage = mediaUrl(seo.og_image || content.hero_image || "");

    document.title = title;
    upsertMeta("name", "description", desc);
    upsertMeta("name", "keywords", seo.keywords || "");
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:url", PUBLIC_URL);
    if (ogImage) upsertMeta("property", "og:image", ogImage);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", desc);
    if (ogImage) upsertMeta("name", "twitter:image", ogImage);

    // canonical
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", PUBLIC_URL);

    // JSON-LD structured data (SportsEvent)
    const ld = {
      "@context": "https://schema.org",
      "@type": "SportsEvent",
      name: event?.name || "Coorg Infinity Run 2027",
      description: desc,
      startDate: event?.date || "2027-01-24",
      eventStatus: "https://schema.org/EventScheduled",
      eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
      location: {
        "@type": "Place",
        name: event?.venue || "Coorg",
        address: {
          "@type": "PostalAddress",
          addressLocality: event?.city || "Coorg",
          addressRegion: "Karnataka",
          addressCountry: "IN",
        },
      },
      image: ogImage ? [ogImage] : undefined,
      organizer: { "@type": "Organization", name: "iDOVENT", url: PUBLIC_URL },
      offers: {
        "@type": "Offer",
        url: `${PUBLIC_URL}/register`,
        availability: "https://schema.org/InStock",
        priceCurrency: "INR",
      },
    };
    let script = document.getElementById("ld-sportsevent");
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "ld-sportsevent";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(ld);
  }, [content, event]);

  return null;
};
